import { FaMoneyBill, FaRegLightbulb } from "react-icons/fa";
import { GiMoneyStack, GiPayMoney, GiRunningNinja } from "react-icons/gi";
import { IoAlert } from "react-icons/io5";
import { MdOutlineSell, MdOutlineShowChart } from "react-icons/md";
import { RiStockFill } from "react-icons/ri";

type Props = {
    icon: string;
}
export default function IconBadge({ icon }: Props) {

    const iconDetails = getIconDetails(icon);

    return <div
        className="badge badge-pill"
        style={{ marginLeft: 0, backgroundColor: iconDetails.backgroundColor, color: iconDetails.titleColor }}
    >
        {iconDetails.title} {iconDetails.icon}
    </div>
}


function getIconDetails(icon: string) {
    const iconDetailsDictionary: any = {
        "preco_barato": {
            backgroundColor: "#06dc3a",
            icon: <FaMoneyBill size={20} color="#FFFFFF" />,
            title: "Preço Barato",
            titleColor: "#FFFFFF"
        },
        "oportunidade": {
            backgroundColor: "#03d1fa",
            icon: <FaRegLightbulb size={20} color="#FFFFFF" />,
            title: "Oportunidade",
            titleColor: "#FFFFFF"
        },
        "oportunidade_longo_prazo": {
            backgroundColor: "#0382fa",
            icon: <MdOutlineShowChart size={20} color="#FFFFFF" />,
            title: "Oportunidade de longo prazo",
            titleColor: "#FFFFFF"
        },
        "oportunidade_curto_prazo": {
            backgroundColor: "#fab303",
            icon: <GiRunningNinja size={20} color="#000000" />,
            title: "Oportunidade de curto prazo",
            titleColor: "#000000"
        },
        "muito_caro": {
            backgroundColor: "#eaea19",
            icon: <GiMoneyStack size={20} color="#000000" />,
            title: "Muito caro",
            titleColor: "#000000"
        },
        "chance_de_melhorar_preco_medio": {
            backgroundColor: "#6c9a4a",
            icon: <GiPayMoney size={20} color="#FFFFFF" />,
            title: "Chance de melhorar preço médio",
            titleColor: "#FFFFFF"
        },
        "tenha_cuidado": {
            backgroundColor: "#f95503",
            icon: <IoAlert size={20} color="#FFFFFF" />,
            title: "Tenha cuidado",
            titleColor: "#FFFFFF"
        },
        "melhor_vender": {
            backgroundColor: "#f90e03",
            icon: <MdOutlineSell size={20} color="#FFFFFF" />,
            title: "Melhor vender",
            titleColor: "#FFFFFF"
        },
        "default": {
            backgroundColor: "#f2f542",
            icon: <RiStockFill size={20} color="#000000" />,
            title: "Neutro",
            titleColor: "#000000"
        }
    }

    return iconDetailsDictionary[icon] ?? iconDetailsDictionary["default"];
}